import styled from "styled-components";

export type StyledCheckboxProps = {
  height?: string;
  width?: string;
};

export const StyledCheckbox = styled.span`
  display: flex;
  width: ${({ width }: StyledCheckboxProps) => width || "10rem"};
  height: ${({ height }: StyledCheckboxProps) => height || "16px"};
`;

export const StyledInput = styled.input.attrs({ type: "checkbox" })`
  transform: scale(1.5);
`;

export const StyledCheckboxLabel = styled.label`
  margin-left: 1rem;
`;
